// extracted by mini-css-extract-plugin
module.exports = {"contactsWrap":"HeaderContacts_contactsWrap_F55Od","phoneIcon":"HeaderContacts_phoneIcon_2kWWD","mail":"HeaderContacts_mail_asQSY","callBack":"HeaderContacts_callBack_3JlOJ"};